import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/search" className="text-sm text-muted-foreground hover:text-foreground hover:underline">
          ← Back to Search
        </Link>
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-foreground">
          Privacy Policy – Vexi
        </h1>

        <p className="mt-3 text-sm text-muted-foreground">Last updated: April 2026</p>

        <div className="mt-8 space-y-5 text-foreground/90 leading-relaxed">
          <p>
            <strong>Privacy Policy – Vexi</strong>
          </p>

          <p>
            Vexi (“we”, “us”, “our”) is a community-driven platform that helps people share and
            discover real prices from local stores.
          </p>

          <p>This Privacy Policy explains what data we collect and how we use it.</p>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">1. Information We Collect</h2>
            <p>We may collect:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>Account information (email, password)</li>
              <li>Location data (if you enable “Near Me”)</li>
              <li>Content you submit (price reports, images, requests)</li>
              <li>Basic usage data (e.g. searches, interactions)</li>
            </ul>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">2. How We Use Your Information</h2>
            <p>We use your data to:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>Provide and improve the service</li>
              <li>Show relevant results based on your location</li>
              <li>Display user-submitted price reports</li>
              <li>Prevent spam or abuse</li>
            </ul>
            <p>
              We do <strong>not sell your personal data</strong>.
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">3. User-Generated Content</h2>
            <p>Any content you submit (prices, photos, comments) may be visible to other users.</p>
            <p>Please ensure the information you share is accurate and appropriate.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">4. Location Data</h2>
            <p>If you enable location services, we use it to show nearby stores and prices.</p>
            <p>You can disable location access at any time in your device settings.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">5. Data Storage &amp; Security</h2>
            <p>We take reasonable steps to protect your data, but no system is completely secure.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">6. Third-Party Services</h2>
            <p>
              We may use third-party services (e.g. maps, hosting) to operate the platform. These
              services may process limited data as needed.
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">7. Your Rights</h2>
            <p>You can:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>Request access to your data</li>
              <li>Request deletion of your account</li>
            </ul>
            <p>
              Contact us at:{' '}
              <a className="text-primary hover:underline" href="mailto:support@vexi.co.za">
                support@vexi.co.za
              </a>
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">8. Changes</h2>
            <p>
              We may update this policy from time to time. Continued use of Vexi means you accept
              the updated policy.
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">9. Contact</h2>
            <p>If you have any questions, contact us at:</p>
            <p>
              <a className="text-primary hover:underline" href="mailto:support@vexi.co.za">
                support@vexi.co.za
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}

